export default "__VITE_ASSET__DwUUYt1Y__"